import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '../Common/styles/Charts.css';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { menus } from './Common/Consts/sidebar';
import GeneralResults from './GeneralResults/GeneralResults';
import Registers from './Registers/Registers';
import Production from './Production/Production';
import { HomeNav } from '../Common/Home/HomeNav';

function DashBoardProductionESus() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />
            <div className="dashboards-page">
                <HomeNav menus={menus} />
                <Routes>
                    <Route
                        path="/"
                        element={<Navigate to="general-results" replace />}
                    />

                    <Route
                        path="/general-results/*"
                        element={<GeneralResults />}
                    />
                    <Route path="/registers/*" element={<Registers />} />
                    <Route path="/production/*" element={<Production />} />
                </Routes>
            </div>
        </QueryClientProvider>
    );
}

export default DashBoardProductionESus;
